export default __webpack_public_path__ + "static/media/Goremonger's Armband.336bb119.jpg";